import {useEffect, useState } from 'react';
import { Board } from '../../../components/Board';
import {
    verifyRoutePermissions
} from '../../../globalFunctions';
import { useNavigate } from 'react-router-dom';
import 'moment/locale/pt';
import { NavButton } from '../../../components/NavButton';
import axios from 'axios';
import QuestionSection from './QuestionSection';
import { questions } from '../../Trilogic/QuestionsRoute/questionList';
import styles from './styles.module.scss'
import { User } from '../../../types';

export const LogicManagerQuestionRoute = () => {
    const [responses, setResponses] = useState<any>({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [userAuth, setUserAuth] = useState({} as User);
    const [toDate, setToDate] = useState<any>(null);
    const [fromDate, setFromDate] = useState<any>(null);
    const [chartImages, setChartImages] = useState<{ [key: string]: string }>({});
    const navigate = useNavigate();

    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified'],
            navigate
        );

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);

    useEffect(() => {
        const fetchResponses = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/answers/statistics`, {
                    params: {
                        fromDate: fromDate ? fromDate.format('YYYY-MM-DD') : null,
                        toDate: toDate ? toDate.format('YYYY-MM-DD') : null,
                    },
                });
                setResponses(response.data);
                console.log(response.data);
            } catch (err) {
                setError("Erro ao buscar respostas.");
            } finally {
                setLoading(false);
            }
        };

        fetchResponses();
    }, [userAuth.id, fromDate, toDate]);

    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
            navigate
        );

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);

    if (loading) return <div>Carregando...</div>;
    if (error) return <div>{error}</div>;
    if (!responses || Object.keys(responses).length === 0) return <div>Nenhuma resposta encontrada.</div>;

    const handleChartReady = (numero, imgURI) => {
        setChartImages(prev => ({ ...prev, [numero]: imgURI }));
    };

    const GenerateAnswers = () => {
        if (!responses || Object.keys(responses).length === 0) return null;

        const content: any = [];
        for (let i = 0; i < questions.length; i++) {
            const questionKey = `question${i + 1}`;
            if (responses[questionKey]) {
                content.push(
                    <QuestionSection
                        key={questionKey}
                        numero={i + 1}
                        responses={responses[questionKey]}
                        className={styles.chartSection}
                        onChartReady={handleChartReady}
                    />
                );
            }
        }
        return content.length > 0
            ? <div className={styles.chartsGrid}>{content}</div>
            : <p>Sem respostas para exibir.</p>;
    };

    const generateReportHTML = () => `
      <html>
        <head>
          <title>Resultados do Questionário</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 2rem; }
            h1 { text-align: center; }
            .chartsGrid { display: grid; gap: 1.5rem; }
            .chartSection { margin-bottom: 2rem; }
          </style>
        </head>
        <body>
          <h1>Resultados do Questionário</h1>
          <div>
            <strong>Data inicial:</strong> ${fromDate ? fromDate.format('DD/MM/YYYY') : '-'}<br/>
            <strong>Data final:</strong> ${toDate ? toDate.format('DD/MM/YYYY') : '-'}
          </div>
          <br/>
          <div class="chartsGrid">
            ${questions.map((q, i) => {
        const questionKey = `question${i + 1}`;
        if (responses[questionKey] && chartImages[i + 1]) {
            return `
                      <div class="chartSection">
                        <h3>${i + 1}. ${q || ''}</h3>
                        <img src="${chartImages[i + 1]}" alt="Chart ${i + 1}" style="max-width:100%;"/>
                        
                      </div>
                    `;
        }
        return '';
    }).join('')}
          </div>
        </body>
      </html>
    `;

    //<pre>${JSON.stringify(responses[questionKey], null, 2)}</pre> se quiser mostrar as respostas em texto ali no espaço abaixo da tag img

    const onPrintReport = () => {
        const iframe = document.getElementById('report-iframe') as HTMLIFrameElement;
        if (iframe?.contentWindow) {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        }
    };

    const goBackwards = () => {
        navigate('/manager');
    };

    return (
        <div className={styles.wrapper}>
            <Board wrapperClass={styles.board}>
                <div id="print-section">
                    <h1 className={styles.title}>Resultados do Questionário</h1>
                    <div className={styles.betweenDates} style={{ display: 'flex', justifyContent: 'center' }}>
                        <button onClick={onPrintReport}>Imprimir Relatório</button>
                        <iframe
                            id="report-iframe"
                            srcDoc={generateReportHTML()}
                            style={{ display: 'none' }}
                            title="Relatório para impressão"
                        />
                        
                    </div>
                    <br />
                    <div className={styles.scrollableContainer}>
                        {GenerateAnswers()}
                    </div>
                    <br />
                </div>
            </Board>
            <NavButton
                direction='left'
                style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
                onClick={goBackwards}
            />
        </div>
    );
};